var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visable)?_c('div',{staticClass:"BreadcrumbComponent"},_vm._l((_vm.BreadcrumbC),function(BreadcrumbValue,i){return _c('div',{key:BreadcrumbValue},[_c('h3',[(i != _vm.BreadcrumbC.length - 1)?_c('div',[_c('router-link',{attrs:{"to":`/${_vm.Breadcrumb.slice(0, i + 1)
              .join('/')
              .toLowerCase()}`}},[_vm._v(" "+_vm._s(BreadcrumbValue)+" ")]),_vm._v("   >   ")],1):_c('div',[_vm._v(" "+_vm._s(BreadcrumbValue)+" ")])])])}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }